import { useEffect, useState } from 'react';
import { Form, Input, Select, DatePicker, Switch, Button, Card, Row, Col, message, Space, Alert } from 'antd';
import { PlusOutlined, MinusCircleOutlined, SaveOutlined, ReloadOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import AdminSidebar from '../Components/Sidebar';
import TextArea from 'antd/es/input/TextArea';
import { createOrUpdateSettings, getSettings } from '../redux/slices/settingsSlice';
import { useDispatch, useSelector } from 'react-redux';

function Faqs() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const dispatch = useDispatch();

    const { settings } = useSelector((state) => state?.settings)

    useEffect(() => {
        dispatch(getSettings())
    }, [dispatch])

    useEffect(() => {
        if (settings?.data) {
            if (settings?.data?.faqs) {
                form.setFieldsValue({
                    faqs : settings?.data?.faqs ? JSON.parse(settings?.data?.faqs) : null
                })
            }
        }
    }, [settings, form])

    const onSubmit = async (values) => {
        setLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));

            const resultAction = await dispatch(createOrUpdateSettings({
                faqs : JSON.stringify(values.faqs),
                type : "FAQs"
            }));

            if (createOrUpdateSettings.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message);
                setAlertType('success');
                setTimeout(() => {
                    setAlertMessage('')
                }, 4000)
            } else {
                setAlertMessage(resultAction?.payload?.error || 'Failed to create update faqs');
                setAlertType('danger');
            }

        } catch (error) {
            setAlertMessage('Failed to update faqs');
            setAlertType('danger');
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <AdminSidebar renderContent={
                <Card
                title="Faqs"
                style={{ marginBottom: 24 }}
            >
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onSubmit}
                    initialValues={{
                        status: "active",
                        notifications: true,
                        faqs: [{ heading: "", content: "" }], // optional initial FAQ
                    }}
                    autoComplete="off"
                    >

                    {/* FAQs List */}
                    <Form.List name="faqs">
                        {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, ...restField }, index) => (
                            <Space
                                key={key}
                                direction="vertical"
                                style={{
                                display: "flex",
                                marginBottom: 16,
                                padding: 16,
                                border: "1px solid #f0f0f0",
                                borderRadius: 8,
                                background: "#fafafa",
                                }}
                            >
                                <Form.Item
                                {...restField}
                                name={[name, "heading"]}
                                label="Heading"
                                rules={[{ required: true, message: "Please enter a heading" }]}
                                >
                                <Input placeholder="Enter heading" />
                                </Form.Item>

                                <Form.Item
                                {...restField}
                                name={[name, "content"]}
                                label="Content"
                                rules={[{ required: true, message: "Please enter content" }]}
                                >
                                <TextArea rows={4} placeholder="Enter content" />
                                </Form.Item>

                                {index > 0 && (
                                    <Button
                                        type="dashed"
                                        danger
                                        icon={<MinusCircleOutlined />}
                                        onClick={() => remove(name)}
                                    >
                                        Remove FAQ
                                    </Button>
                                )}
                            </Space>
                            ))}

                            <Form.Item>
                            <Button
                                type="dashed"
                                onClick={() => add()}
                                block
                                icon={<PlusOutlined />}
                            >
                                Add FAQ
                            </Button>
                            </Form.Item>
                        </>
                        )}
                    </Form.List>

                    {/* Submit + Reset */}
                    <Form.Item>
                        <Space>
                        <Button
                            type="primary"
                            htmlType="submit"
                            icon={<SaveOutlined />}
                            loading={loading}
                            size="large"
                        >
                            Submit
                        </Button>
                        </Space>
                    </Form.Item>
                </Form>

            </Card>
            } />
        </>
    );
}

export default Faqs;